import styled from 'styled-components';
import { GREY_500 } from '../../constants';

export default styled.h1`
    font-size: 1.55rem;
    font-weight: 400;
    color: ${GREY_500};
    text-align: center;
`;
